import { render } from "./PetiteVoiePage.vue?vue&type=template&id=fe0851b0"
import script from "./PetiteVoiePage.vue?vue&type=script&lang=js"
export * from "./PetiteVoiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__